//=============================================
// GLOBAL NAMESPACE
//=============================================
var am = (function (module) {
    
    // Use strict mode
    'use strict';


    /**
     * Class used to translate strings
     * @param {String} sTradVersion numero de version de traduction #3038
     */
    module.Translator = function (sTradVersion) {
        this.debugMode=false;
        this._sTradVersion=sTradVersion;
    };

    /**
     * Class constructor
     * @constructor
     *
     * @param {Object} config - Configuration of the class instance
     */
    module.Translator.prototype.init = function(config,fnCallBack) {
        //recuperation des bonne options #2306
        if(config.hasOwnProperty("translation")){
            this._avalaibleTrad=config.translation.availableTrad;
            var urlParams = am.utils.getUrlParameters();//#172
            var lang=config.translation.default
            if(urlParams.hasOwnProperty("lang")){
                this._avalaibleTrad.forEach(function(oTrad){
                    if(oTrad.label==urlParams.lang)
                        lang=oTrad.id;
                })
            }
            this.setLanguage(lang,fnCallBack);
            
            if(config.hasOwnProperty("debugMode")){
                this.debugMode=config.debugMode;
            }
        }else{
            this._avalaibleTrad=[{id:"default"}];
            this.setLanguage("default",fnCallBack);
        }
    };


    /**
     * Chargement du fichier de traduction
     * 
     * @param {Function} callBack function de callBack
     */
    module.Translator.prototype._loadConf = function(fnCallBack) {
        var _this =this;
        $.ajax({
            dataType: "json",
            url: "/app/" +  _this._currentTrad + ".js?rev="+_this._sTradVersion,//#2306 en JS pour le cache ( ne pas requeter des .json (statique))
            success: function(data) {
                console.log("Successfully loaded traduction config file associated with project '" + _this._currentTrad + "'");
                _this.oTradA=data;
                if (fnCallBack !== undefined) {
                    fnCallBack();
                }
            },
            error: function(jqXHR, textStatus) {
                throw new Error("Cannot load traduction file associated with project '" + _this._currentTrad + "': " + textStatus);
            }
        });
    };


    /**
     * Class destructor
     */
    module.Translator.prototype.destroy = function() {
        // nothing to do for the moment
    };

    /**
     * Function setting the language in which the strings should be translated.
     *
     * @param {String} language - Language to use, either specified as a two-letter code (e.g. 'FR', 'EN', etc.) or as a 
     *      full string (e.g. 'french', 'english', etc.)
     */
    module.Translator.prototype.setLanguage = function(language,fnCallBack) {
        //#2306 recherche de la langue dans celles disponibles;
        var languageFound = false;
        for(var iNumLanguage =0;iNumLanguage<this._avalaibleTrad.length;iNumLanguage++){
            var oLang=this._avalaibleTrad[iNumLanguage];
            if(oLang.id===language){
                this._currentTrad=language;
                this._loadConf(fnCallBack);
                languageFound =true;
                break;
            }
        }
        if (!languageFound) {
            throw new Error("Cannot set language to '" + language + "': unknown language");
            if (fnCallBack !== undefined) {
                fnCallBack();
            }
        }
    };

    /**
     * Function returning the language in which the strings should be translated.
     *
     * @param {Boolean} asShortString - Should the language be returned as a short (two-letter) code or as a full 
     *      string? [defaults to a full string]
     * @return {String} - Language used
     */
    module.Translator.prototype.getLanguage = function(bLabel) {
        //#172
        if(!bLabel)
            return this._currentTrad;

        for(var iNumLanguage =0;iNumLanguage<this._avalaibleTrad.length;iNumLanguage++){
            var oLang=this._avalaibleTrad[iNumLanguage];
            if(oLang.id===this._currentTrad){
                return oLang.label;
            }
        }
        //return asShortString ? this._languageCode : LANGUAGES[this._languageCode];
    };

    /**
     * Function translating the input string
     *
     * @param {string} string - String to be translated
     * @return {string} - Translated string
     */
    module.Translator.prototype.translate = function(string) {

        if(this.oTradA.hasOwnProperty(string)){
            if(this.debugMode){
                return "--"+this.oTradA[string]+"--";
            }else{
                return this.oTradA[string];
            }
        }else{
            console.warn("MISSING TRAD",string);
            return string;
        }
   
    };

    /**
     * Function returning the input number formatted as a string
     *
     * @param {Number} num - Number to be returned as a string
     * @param {Number} precision - Number of decimals to be printed in the output string. Defaults to 0.
     * @return {String} - Number formatted according to the currently selected language
     */
    module.Translator.prototype.formatNumber = function(num, precision) {
        precision = precision || 0;
        if (precision < 0) {
            precision = Math.pow(10, -precision);
            if (num > precision) {
                num = Math.round(num / precision) * precision;
            }
            precision = 0;
        }
        return num.toLocaleString(this._languageCode, {
            minimumFractionDigits: precision,
            maximumFractionDigits: precision
        });
    };    

    return module;
    
})(am || {});


//=============================================
// AM.UTILS NAMESPACE
//=============================================
am.utils = (function(module) {

    // Use strict mode
    'use strict';

    /**
     * Function returning a new instance of class am.Translator
     *
     * @param {Object} config - Configuration of the new instance
     * @param {Strinf} sTradVersion - version de la traduction #3038
     * @return {am.Translator} - New instance of class am.Translator
     */
    module.translator = function(config,sTradVersion,fnCallBack) {
        var translator = new am.Translator(sTradVersion);
        translator.init(config,fnCallBack);
        return translator;
    };

    return module;

})(am.utils || {});